import React from 'react';

function Metrics() {
  return (
    <h2>Metrics are comming soon!</h2>
  );
}

export default Metrics;
